module.exports = __webpack_public_path__ + "img/calendar-month.e614c4e4.svg";